import { Box, Skeleton, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useFilter } from 'src/context/FilterContext'

export const refreshExpandedWidth = 120
export const refreshCollapsedWidth = 45

const RefreshStatus = () => {
  const { activeModuleEndDate, moduleDateFilterLoading } = useFilter()
  const navigate = useNavigate()

  return (
    <Box>
      <Box position="relative">
        <Box
          sx={{
            m: '8px',
            px: 2,
            transition: '0.2s ease',
            backgroundColor: '#091F2D',
            color: '#FFFFFF',
            cursor: 'pointer',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: refreshCollapsedWidth
          }}
          onClick={() => {
            navigate('/data-refresh-status')
          }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ alignItems: 'center' }}>
            {moduleDateFilterLoading ? (
              <Skeleton
                variant="rounded"
                sx={{ height: '14px', width: 'calc(100% - 30px)', bgcolor: '#fff2' }}
              />
            ) : (
              <Typography
                variant="subtitle1"
                color="#FFFFFF"
                sx={{ fontSize: 11, fontWeight: 400, lineHeight: 'initial' }}>
                Data Until : {activeModuleEndDate ? moment(activeModuleEndDate).format('D MMM, YYYY') : '—'}
              </Typography>
            )}
          </Stack>
        </Box>
      </Box>
    </Box>
  )
}
export default RefreshStatus
